import React from 'react';
import styles from './Button.module.css';
import clsx from 'clsx';

type ButtonVariant = 'primary' | 'secondary' | 'outline' | 'outline-inverse';

const variantClass: Record<ButtonVariant, string> = {
  primary: styles.primary,
  secondary: styles.secondary,
  outline: styles.outline,
  'outline-inverse': styles.outlineInverse,
};

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode;
  variant?: ButtonVariant;
  size?: 'sm' | 'md' | 'lg';
  fullWidth?: boolean;
  as?: React.ElementType;
  href?: string;
}

export const Button: React.FC<ButtonProps> = ({
  children,
  variant = 'primary',
  size = 'md',
  fullWidth = false,
  className,
  as,
  href,
  ...props
}) => {
  const Component = as || (href ? 'a' : 'button');

  return (
    <Component
      className={clsx(
        styles.button,
        variantClass[variant],
        styles[size],
        fullWidth && styles.fullWidth,
        className
      )}
      href={href}
      {...props}
    >
      {children}
    </Component>
  );
};
